import TextArea, { TextareaProps } from '@/components/atoms/legacy/TextArea';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

export interface FormTextareaProps extends TextareaProps {
  label?: string;
  invalid?: boolean;
  errorMessage?: string;
  labelClassname?: string;
}

const FormTextarea: React.FC<FormTextareaProps> = ({
  className = '',
  label,
  invalid,
  errorMessage,
  labelClassname,
  ...props
}) => {
  return (
    <section className={`${className}`}>
      <label className="text-body2Regular text-neutral-800">
        {label && (
          <span className={`mb-[4px] block ${labelClassname}`}>{label}</span>
        )}
        <TextArea className={`w-full ${invalid ? 'error' : ''}`} {...props} />
        {errorMessage && (
          <span className={`error-message ${invalid ? 'flex' : ''}`}>
            <ExclamationCircleIcon className="mr-xs size-l fill-red-light" />
            {errorMessage}
          </span>
        )}
      </label>
    </section>
  );
};

export default FormTextarea;
